import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/auxiliaryMateriel'

/** 获取报工记录 */
// export const getAuxiliaryMaterielByProcessFlowOrder = (params) => {
//   return axios.get(`${rootApi}/getAuxiliaryMaterielByProcessFlowOrder`, {params})
// }
// /添加记录/
export const simplifyRegister=(auxiliaryMaterielDtoJson) => {
  return axios.post(`${rootApi}/simplifyRegister`,auxiliaryMaterielDtoJson)
}
// /扫码/
export const getByBatchSecond=(params) => {
  return axios.get(`${rootApi}/getByBatchSecond`,{params})
}

// /工艺标准/
export const getCraftStandard=(params) => {
  return axios.get(`/api_v2/technology/craftStandard/getCraftStandard`,{params})
}
// /机器参数/
export const getBlownFilmMachineData=(params) => {
  return axios.get(`/api_v2/equipment/getBlownFilmMachineData`,{params})
}
// /领取工单机器参数/
export const getDeviceMachineData=(params) => {
  return axios.get(`/api_v2/production/productionOrder/getDeviceMachineData`,{params})
}
// /工单膜卷/
export const getMembraneByTaskId=(params) => {
  return axios.get(`/api_v2/production/reportRecord/getMembraneByTaskId`,{params})
}
// /压花工单膜卷/
export const getMembraneByOrderId=(params) => {
  return axios.get(`/api_v2/production/reportRecord/getMembraneByOrderId?id=${params}`)
}
// /订单/
export const getOrderByMateriel=(params) => {
  return axios.post(`/api_v2/production/productionOrder/getOrderByMateriel`,params,{dataType: 'json'})
}

